import { NgModule,CUSTOM_ELEMENTS_SCHEMA  } from "@angular/core";
import { FooterComponent } from "./components/footer/footer.component";
import { NavComponent } from "./components/nav/nav.component";
import { CommonModule } from "@angular/common"; 

const COMPONENTS = [ 
    NavComponent,
    FooterComponent
  ];
  
  @NgModule({
    declarations: [...COMPONENTS],
    imports: [
      CommonModule
    ],
    providers:[ 
    ],
    exports: [...COMPONENTS],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
  })
  export class SharedModule { }
  